import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BDFilterDeviceCategory } from '@brother-apps/brother-dealerapp-shared-lib';

@Component({
    selector: 'bdcp-filter-device-category',
    templateUrl: './filter-device-category.component.html',
    styleUrls: ['./filter-device-category.component.scss']
})
export class BDCPFilterDeviceCategoryComponent {

    @Input() public category: BDFilterDeviceCategory;

    @Output() public selected = new EventEmitter<void>();

    public clicked(): void {
        this.category.selected = !this.category.selected;
        this.selected.emit();
    }
}
